export default __webpack_public_path__ + "static/media/PakistanFlag.9c46f0cd.png";